import {
  queryOptions,
  skipToken,
  useMutation,
  useQueries,
  useQuery,
  useQueryClient,
} from '@tanstack/react-query'
import { useMemo } from 'react'

import { workspacesApi } from '../../data/api/workspaces.api'
import type { ListParams } from '../../data/types/ListParams'
import type { WorkspaceUpsert } from '../models/Workspace'


export const workspacesKeys = {
  all: ['workspaces'] as const,
  list: (params: ListParams) => ['workspaces', params] as const,
  count: (filter?: Record<string, unknown>) => ['workspaces', 'count', { filter }] as const,
  detail: (id: string | undefined) => ['workspaces', 'detail', id] as const,
//   status: (id: string, action?: ActivityAction) => ['commercials', 'status', id, action] as const,
//   polling: (id: string | undefined) => ['commercials', 'polling', id] as const,
}

export function useWorkspaces(params: ListParams) {
  return useQuery({
    queryKey: workspacesKeys.list(params),
    queryFn: () => workspacesApi.list(params.skip, params.top, params.filter).then((r) => r.data),
  })
}

export function useWorkspacesCount(filter?: Record<string, unknown>) {
  return useQuery({
    queryKey: workspacesKeys.count(filter),
    queryFn: () => workspacesApi.count(filter).then((r) => r.data),
  })
}

export function useWorkspace(id: string | undefined) {
  return useQuery({
    queryKey: workspacesKeys.detail(id),
    queryFn: id ? () => workspacesApi.detail(id).then((r) => r.data) : skipToken,
  })
}

export function useWorkspacesCreate() {
  const qc = useQueryClient()
  return useMutation({
    mutationFn: (data: WorkspaceUpsert) => workspacesApi.create(data).then((r) => r.data),
    onSuccess: () => qc.invalidateQueries({ queryKey: workspacesKeys.all }),
  })
}

export function useWorkspacesUpdate() {
  const qc = useQueryClient()
  return useMutation({
    mutationFn: ({ id, data }: { id: string; data: WorkspaceUpsert }) =>
      workspacesApi.update(id, data).then((r) => r.data),
    onSuccess: (_data, { id }) => {
      qc.invalidateQueries({ queryKey: workspacesKeys.all })
      qc.invalidateQueries({ queryKey: workspacesKeys.detail(id) })
    },
  })
}

export function useWorkspacesDelete() {
  const qc = useQueryClient()
  return useMutation({
    mutationFn: (id: string) => workspacesApi.delete(id).then((r) => r.data),
    onSuccess: () => qc.invalidateQueries({ queryKey: workspacesKeys.all }),
  })
}

// export function useCommercialStatus(
//   commercialId: string | undefined,
//   action?: ActivityAction,
//   enabled = false,
// ) {
//   return useQuery({
//     queryKey: workspacesKeys.status(commercialId ?? '', action),
//     queryFn:
//       commercialId && enabled
//         ? () => commercialsApi.status(commercialId, action).then((r) => r.data.status)
//         : skipToken,
//     refetchInterval: (query) =>
//       GENERATION_STATUSES.some((value) => value === query.state.data) ? 5000 : false,
//   })
// }

// function commercialStatusOptions(commercialId: string | undefined) {
//   return queryOptions({
//     queryKey: commercialsKeys.polling(commercialId),
//     queryFn: commercialId
//       ? () => commercialsApi.status(commercialId).then((r) => r.data.status)
//       : skipToken,
//     refetchInterval: 5000,
//   })
// }

// export type GenerationStatusSets = Record<string, GenerationStatus | undefined>

// export function useCommercialsStatuses(data: Commercial[]): GenerationStatusSets {
//   const results = useQueries({
//     queries: data.map((commercial) => commercialStatusOptions(commercial.id)),
//   })

//   const resultsKey = results.map((r) => r.data).join(',')
//   return useMemo<GenerationStatusSets>(() => {
//     const statuses: GenerationStatusSets = {}
//     data.forEach((commercial, index) => {
//       statuses[commercial.id] = results[index]?.data
//     })
//     return statuses
//     // eslint-disable-next-line react-hooks/exhaustive-deps
//   }, [resultsKey])
// }
